<template>
  <div 
    v-loading="posterLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="dilog-box-loading">
    <div ref="poster" id="poster" class="poster">
      <!-- 背景图 -->
      <!-- <el-image
        :src="backgroundImage"
        alt="Background"
        @load="handleImageLoad" 
        @error="handleImageError"
        class="background-image"
      >
      </el-image> -->
      
      <img 
        v-if="type === 1"
        src="./../assets/xi_11.png" 
        alt="Background" 
        class="background-image"
      >
      <img 
        v-if="type === 2"
        src="./../assets/xi_12.png" 
        alt="Background" 
        class="background-image"
      >
      <img 
        v-if="type === 3"
        src="./../assets/xi_13.png" 
        alt="Background" 
        class="background-image"
      >

      <!-- 文字 -->
      <div class="poster-text">
        <div class="text-1">
          截至{{ formatDate(time) }}
        </div>
        <div class="text-2">
          <div>
            {{ name }}
          </div>
        </div>
      </div>
      <div class="poster-text-center">
        <div class="poster-text-center_1">
          突破{{ formatNumber(amount) }}<span>份</span>
        </div>
        <div class="poster-text-center_2">
          <div>主问卷&nbsp;{{ formatNumber_s(rowData.amount) }}<span>{{formatUnit(rowData.amount)}}份</span></div>
          <span>&nbsp;&nbsp;</span>
          <div>专题问卷&nbsp;{{ formatNumber_s(rowData.specialAmount) }}<span>{{formatUnit(rowData.specialAmount)}}份</span></div>
        </div>
      </div>
    </div>
    <div style="margin-top:20px;">
      <el-button
        v-if="isPc"
        type="primary"
        @click="generatePoster"
      >
        保存本地
      </el-button>
      <el-button
        v-else
        type="primary"
        @click="openImg"
      >
        保存本地
      </el-button>
    </div>
    
  </div>
</template>

<script>

import html2canvas from 'html2canvas';
export default {
  name: 'CustomButton',
  props: {
    type: {
      type: Number,
      default: 1
    },
    isPc: {
      type: Boolean,
      default: false
    },
    amount: {
      type: Number,
      default: 0
    },
    rowData: {
      type: Object,
      default: {
        amount: 0, // 主问卷总量
        specialAmount: 0, // 主问卷总量
      }
    },
    name: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: () => {} // 默认点击事件为空函数
    }
  },
  data() {
    return {
      posterLoading: false,
      imgList: [
        {
          id: 1,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/9a5402379a3d48bf95e5cbdc957a061e.jpg',
          name: '橙色'
        },
        {
          id: 2,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/77696e082eb74cf4a77a06dede98e84c.png',
          name: '红色'
        },
        {
          id: 5,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/48a5a8f0adb2414fbbe0905149d1fc74.png',
          name: '深蓝色'
        }
      ],
      backgroundImage: '',
    }
  },
  created() {
    console.log('rowData',this.rowData)
    // if(!!this.type) {
    //   let bgImg = this.imgList.find(item=>item.id === this.type);
    //   this.backgroundImage = bgImg.img;
    // }
  },
  methods: {
    formatNumber(value) {
      if (value >= 100000) {
        return `${Math.floor(value / 10000)}万`;
      } else if (value >= 10000) {
        return parseInt(value / 1000) * 1000;
      } else if (value >= 1000) {
        return parseInt(value / 100) * 100;
      } else {
        return parseInt(value / 10) * 10;
      }
    },
    // 格式化数值的方法
    formatNumber_s(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.amount >= 100000) {
        return (value / 10000).toFixed(4);
      } else {
        return value;
      }
    },
    formatUnit(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.amount >= 100000) {
        return '万';
      } else {
        return '';
      }
    },
    handleImageLoad(event) {
      console.log('图片加载完成', event);
      this.posterLoading=false;
      // 执行图片加载完成后的逻辑
    },
    handleImageError(event) {
      console.log('图片加载失败', event);
      // 处理图片加载失败的逻辑
    },
    handleClick() {
      // 调用传入的点击事件处理器
      this.onClick();
    },
    openImg() {
      this.$nextTick(()=>{
        console.log('this.$refs.poster',this.$refs.poster)
        if(this.$refs.poster.id == 'poster') {
          const posterElement = this.$refs.poster;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
            scale: window.devicePixelRatio,
          }).then(canvas => {
              // 将 Canvas 转换为 Blob 对象
              canvas.toBlob((blob) => {
                // 创建一个临时链接
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${this.name}-${this.amount}喜报.jpg`; // 设置下载文件的名称

                // 触发点击事件
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();

                // 释放临时链接
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              });
          }).catch(err => {
            this.$message.error(err);
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })
    },
    generatePoster() {
      this.$nextTick(()=>{
        if(this.$refs.poster.id == 'poster') {
          const posterElement = this.$refs.poster;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
          }).then(canvas => {
            const posterImage = canvas.toDataURL('image/jpg');
            // 在这里你可以保存或显示生成的海报图像
            // 如果要保存为文件，可以创建一个下载链接
            const link = document.createElement('a');
            link.href = posterImage;
            link.download = `${this.name}-${this.amount}喜报.jpg`;
            link.click();
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })
      
    },
    formatDate(dateString) {
      // 将日期字符串转换为Date对象
      const dateStr = dateString.replace(/-/g,"/");
      const date = new Date(dateStr);

      // 获取月、日、小时、分钟
      const month = date.getMonth() + 1; // getMonth() 返回的月份是从0开始的
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // 格式化月、日、小时、分钟（补零）
      const monthStr = month < 10 ? `0${month}` : `${month}`;
      const dayStr = day < 10 ? `0${day}` : `${day}`;
      const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
      const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;

      // 拼接格式化后的日期字符串
      return `${monthStr}月${dayStr}日 ${hoursStr}:${minutesStr}`;
      // return `${date}`;
    }
  }
};
</script>

<style scoped>
.dilog-box-loading {
  min-height: 960px;
  display:flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content:center;
}
.poster {
  position: relative;
  width: 540px;
  height: 960px;
  margin-bottom: 20px;
}
.background-image {
  width: 100%;
  height: 100%;
}

.poster-text {
  position: absolute;
  top: 42%;
  left: 50%;
  bottom: 49%;
  transform: translateX(-50%);
  color: #EE3C38;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.poster-text .text-1 {
  color: #FE3232;
  font-family: CustomFont6;
  letter-spacing: 1px;
  font-size: 20px;
  line-height: 22px;
}
.poster-text .text-2 {
  flex: 1;
  color: #DA2618;
  font-family: CustomFont5;
  width: 92%;
  line-height: 24px;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.poster-text .text-2 div{
  width: 80%;
}
.poster-text-center {
  position: absolute;
  top: 54.5%;
  left: 50%;
  bottom: 34%;
  width: 80%;
  transform: translateX(-50%);
  color: #EE3C38;
  font-family: CustomFont4;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.poster-text-center_1 {
  letter-spacing: 1px;
  font-size: 62px;
  line-height: 62px;
}
.poster-text-center_1 span {
  font-size: 22px;
}
.poster-text-center_2 {
  flex: 1;
  display: flex;
  font-size: 17px;
  line-height: 20px;
  color: rgb(238, 60, 56);
  justify-content: center;
}
.poster-text-center_2 span {
  font-size: 14px;
}
.qr-box {
  position: absolute;
  top: 66%;
  left: 50%;
  bottom: 26%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}
.qr-image {
  width: 65px;
  height: 65px;
}
@media screen and (max-width: 768px) {
  .dilog-box-loading {
    min-height: calc( 960px / 3 * 2 );
  }
  .poster {
    width: calc( 540px / 3 * 2 );
    height: calc( 960px / 3 * 2 );
    margin-bottom: 10px;
  }
  .poster-text .text-1 {
    font-size: 14px;
    line-height: 16px;
  }
  .poster-text .text-2 {
    line-height: 20px;
    font-size: 18px;
  }
  .poster-text-center_1 {
    font-size: 40px;
    line-height: 40px;
  }
  .poster-text-center_1 span {
    font-size: 20px;
  }
  .poster-text-center_2 {
    font-size: 12px;
    line-height: 14px;
  }
  .poster-text-center_2 span {
    font-size: 8px;
  }
  .qr-box {
    top: 66%;
    bottom: 28%;
  }
  .qr-image {
    width: 42px;
    height: 42px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/poster.vue